module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    staticClass: "form-horizontal ng-pristine ng-valid-mask ng-valid-maxlength ng-valid-minlength ng-valid-max ng-valid-date ng-valid ng-valid-required",
    attrs: {
      "name": "frmRegNotice",
      "novalidate": "",
      "_lpchecked": "1"
    }
  }, [_c('div', {
    staticClass: "form-group required"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "extensao"
    }
  }, [_vm._v("Extensão:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoDoArquivo),
      expression: "tipoDoArquivo"
    }],
    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "type": "radio",
      "name": "status",
      "value": "1",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.tipoDoArquivo, "1")
    },
    on: {
      "change": function($event) {
        _vm.tipoDoArquivo = "1"
      }
    }
  }), _vm._v(" PDF\n                      "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoDoArquivo),
      expression: "tipoDoArquivo"
    }],
    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "type": "radio",
      "name": "status",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.tipoDoArquivo, "2")
    },
    on: {
      "change": function($event) {
        _vm.tipoDoArquivo = "2"
      }
    }
  }), _vm._v(" Excel\n                      "), _c('div', {
    staticClass: "new-control-indicator"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.errors.first('tipoDoArquivo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "tipoDoArquivo"
    }
  }, [_vm._v("Relatório:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorio),
      expression: "relatorio"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "name": "tipoRelatorio"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.relatorio = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.tipoDoArquivo == 1) ? _c('option', {
    attrs: {
      "value": "ANALISE"
    }
  }, [_vm._v("Análise")]) : _vm._e(), _vm._v(" "), (_vm.tipoDoArquivo == 1) ? _c('option', {
    attrs: {
      "value": "PROPOSTA"
    }
  }, [_vm._v("Proposta")]) : _vm._e(), _vm._v(" "), (_vm.tipoDoArquivo == 2) ? _c('option', {
    attrs: {
      "value": "APLICACAO"
    }
  }, [_vm._v("Proposta")]) : _vm._e()]), _vm._v(" "), (_vm.errors.first('')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipoDoArquivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [(_vm.relatorio !== '') ? _c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "href": "javascript:void(0)",
      "type": "button"
    },
    on: {
      "click": _vm.onDownload
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Gerar")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClean
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Limpar")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Impressão de Relatórios")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c9fe5b3a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/relatorios/ImpressaoRelModal.vue
// module id = 2078
// module chunks = 1